<template>

  <svg
    t="1639126773926"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3983"
    width="64"
    height="64"
  ><path d="M714.047488 875.04759467a50.331648 50.331648 0 0 1-61.16693333-4.390912L322.05482667 575.504384a84.91281067 84.91281067 0 0 1 0-126.98692267L652.85870933 153.321472a50.331648 50.331648 0 0 1 62.76164267-3.2768c16.318464 12.058624 19.68264533 34.95253333 7.51479467 51.11808l-204.95291734 272.52053333a63.635456 63.635456 0 0 0 0 76.58973867l204.95291734 272.52053333 1.13595733 1.572864a36.32878933 36.32878933 0 0 1-10.223616 50.659328z" p-id="3984" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconArrowLeft',
} as DefineComponent
</script>